import React from "react";

const AnnouncementBanner = () => {
  return (
    <div className="bg-gradient-to-r from-[#8932c8] via-[#a855f7] to-[#8932c8] py-2 md:py-3 overflow-hidden">
      <div className="flex items-center">
        {/* Fixed Logo - Hidden on very small screens, smaller on mobile */}
        <div className="hidden sm:flex flex-shrink-0 bg-white px-3 md:px-5 py-1.5 md:py-2 rounded-r-full shadow-lg z-10">
          <img 
            src="/images/nasscom-deeptech-club.png" 
            alt="NASSCOM DeepTech Club" 
            className="h-6 md:h-10 w-auto"
          />
        </div>
        
        {/* Running Text */}
        <div className="flex-1 overflow-hidden ml-2 sm:ml-4">
          <div className="animate-marquee whitespace-nowrap flex items-center">
            <span className="text-white font-medium text-xs sm:text-sm md:text-base mx-4 sm:mx-8">
              🎉 Big news! We're thrilled to announce that Spharaka Networks has been selected for the prestigious NASSCOM DeepTech Club Launchpad Program, an exciting leap forward in our DeepTech journey!
            </span>
            <span className="text-white font-medium text-xs sm:text-sm md:text-base mx-4 sm:mx-8">
              🎉 Big news! We're thrilled to announce that Spharaka Networks has been selected for the prestigious NASSCOM DeepTech Club Launchpad Program, an exciting leap forward in our DeepTech journey!
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;